module.exports = __webpack_public_path__ + "img/ched-header-logo-cropped.7f3a3eee.png";